import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import AnalyzePage from "./pages/AnalyzePage";
import MarketOverview from "./pages/MarketOverview";
import ToolsPage from "./pages/ToolsPage";
import UsageInsights from "./pages/UsageInsights";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import SharedCardPage from "./pages/SharedCardPage";
import ContactPage from "./pages/ContactPage";
import AdminCentre from "./pages/AdminCentre";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AnalyzePage />} />
        <Route path="/markets" element={<MarketOverview />} />
        <Route path="/tools" element={<ToolsPage />} />
        <Route path="/usage" element={<UsageInsights />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/r/:cardId" element={<SharedCardPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/admin" element={<AdminCentre />} />
        <Route path="/admin/enquiries" element={<Navigate to="/admin" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
